import React from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import LoadingSpinner from "../../../../partials/loading";
import NewIBMToolForm from "./NewItem";
import BMIPercentageCal from "./PercentageCal";
import BMIListing from "./ItemListing";
import BMIGuideline from "./BMIGuideline";
import { LIST, CREATE } from "../../../../queries/bmi.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { ReadData } from "../../../../providers/Patient.Provider";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";

function BMITool() {
    const title = "Malnutrition Screening Tool-BMI";
    // local data
    const patient = ReadData();
    // query
    const { loading, data } = useQuery(LIST, {
        variables: { id: patient.id },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    // Mutation
    const [CreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        update(caches, { data: { RecordBMI } }) {
            const { GetBMIList } = caches.readQuery({
                // Get list
                query: LIST,
                variables: { id: patient.id },
            });
            // Add to list
            GetBMIList.docs.unshift(RecordBMI.doc);
            caches.writeQuery({
                query: LIST,
                variables: { id: patient.id },
                data: { GetBMIList },
            });
        },
        onCompleted: (data) => {
            toast.success(data.RecordBMI.message);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-head">
                            <header>Physical Health {title}</header>
                        </div>
                        <div className="card-body">
                            <LoadingSpinner loading={loading} />
                            {data && <BMIListing items={data.GetBMIList.docs} />}
                        </div>
                        <div className="card-body">
                            <BMIPercentageCal />
                        </div>
                        <div className="card-body">
                            <NewIBMToolForm
                                onSave={async (item) => {
                                    await CreateFunc({
                                        variables: {
                                            model: {
                                                ...item,
                                                patient: patient.id,
                                            },
                                        },
                                    });
                                }}
                            />
                            <LoadingSpinner loading={cLoading} bar={true} />
                        </div>
                        <div className="card-body">
                            <BMIGuideline />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default BMITool;
